/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface InsertOrganisationRequest
 */
export interface InsertOrganisationRequest {
    /**
     *
     * @type {string}
     * @memberof InsertOrganisationRequest
     */
    organisationId?: string;
    /**
     *
     * @type {string}
     * @memberof InsertOrganisationRequest
     */
    fullName?: string;
    /**
     *
     * @type {number}
     * @memberof InsertOrganisationRequest
     */
    rowSequence?: number;
    /**
     *
     * @type {string}
     * @memberof InsertOrganisationRequest
     */
    externalMaintenanceTicketingName?: string;
    /**
     * The max number of devices that users in this org can create.
     * @type {number}
     * @memberof InsertOrganisationRequest
     */
    deviceProvisioningLimit?: number;
    /**
     * The group ids the new organisation is part of
     * @type {Array<string>}
     * @memberof InsertOrganisationRequest
     */
    organisationGroupIds?: Array<string>;
}

/**
 * Check if a given object implements the InsertOrganisationRequest interface.
 */
export function instanceOfInsertOrganisationRequest(
    value: object,
): value is InsertOrganisationRequest {
    return true;
}

export function InsertOrganisationRequestFromJSON(
    json: any,
): InsertOrganisationRequest {
    return InsertOrganisationRequestFromJSONTyped(json, false);
}

export function InsertOrganisationRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): InsertOrganisationRequest {
    if (json == null) {
        return json;
    }
    return {
        organisationId:
            json["organisationId"] == null ? undefined : json["organisationId"],
        fullName: json["fullName"] == null ? undefined : json["fullName"],
        rowSequence:
            json["rowSequence"] == null ? undefined : json["rowSequence"],
        externalMaintenanceTicketingName:
            json["externalMaintenanceTicketingName"] == null
                ? undefined
                : json["externalMaintenanceTicketingName"],
        deviceProvisioningLimit:
            json["deviceProvisioningLimit"] == null
                ? undefined
                : json["deviceProvisioningLimit"],
        organisationGroupIds:
            json["organisationGroupIds"] == null
                ? undefined
                : json["organisationGroupIds"],
    };
}

export function InsertOrganisationRequestToJSON(
    value?: InsertOrganisationRequest | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        organisationId: value["organisationId"],
        fullName: value["fullName"],
        rowSequence: value["rowSequence"],
        externalMaintenanceTicketingName:
            value["externalMaintenanceTicketingName"],
        deviceProvisioningLimit: value["deviceProvisioningLimit"],
        organisationGroupIds: value["organisationGroupIds"],
    };
}
